import { frontendURL } from 'dashboard/helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';
import AppContainer from 'dashboard/routes/dashboard/Dashboard.vue';
import SufficitIntegration from './routes/settings/integrations/Sufficit.vue';
import { buildSufficitSipExtensionProvider } from './hooks/sipExtensionProvider';

const ensurePluginState = () => {
  if (!window.chatwoot) {
    window.chatwoot = {};
  }

  if (!window.chatwoot.plugins) {
    window.chatwoot.plugins = {};
  }

  if (!window.chatwoot.plugins.sufficit) {
    window.chatwoot.plugins.sufficit = {};
  }

  return window.chatwoot.plugins.sufficit;
};

const registerIntegrationRoute = () => {
  const router = window.chatwootRouter;
  if (
    !router?.addRoute ||
    router?.hasRoute?.('settings_integrations_sufficit')
  ) {
    return;
  }

  router.addRoute({
    path: frontendURL('accounts/:accountId'),
    component: AppContainer,
    children: [
      {
        path: 'settings/integrations/sufficit',
        name: 'settings_integrations_sufficit',
        component: SufficitIntegration,
        meta: {
          featureFlag: FEATURE_FLAGS.INTEGRATIONS,
          permissions: ['administrator'],
        },
      },
    ],
  });
};

const rematchCurrentSufficitRoute = () => {
  const router = window.chatwootRouter;
  const currentRoute = router?.currentRoute?.value;

  if (!router?.replace || !currentRoute) {
    return;
  }

  const isGenericIntegrationRoute =
    currentRoute.name === 'settings_applications_integration' &&
    currentRoute.params?.integration_id === 'sufficit';
  const isSufficitPath = currentRoute.path?.includes(
    '/settings/integrations/sufficit'
  );

  if (!isGenericIntegrationRoute && !isSufficitPath) {
    return;
  }

  const accountId =
    currentRoute.params?.accountId || currentRoute.params?.account_id;
  if (!accountId) {
    return;
  }

  Promise.resolve().then(() =>
    router
      .replace({
        name: 'settings_integrations_sufficit',
        params: { accountId },
        query: currentRoute.query,
        hash: currentRoute.hash,
      })
      .catch(() => { })
  );
};

export default {
  install(app, { PluginSystem } = {}) {
    const pluginState = ensurePluginState();

    registerIntegrationRoute();
    rematchCurrentSufficitRoute();

    if (PluginSystem && !pluginState.sipExtensionProviderRegistered) {
      PluginSystem.registerHook(
        'sip:extension-form-provider',
        buildSufficitSipExtensionProvider
      );
      pluginState.sipExtensionProviderRegistered = true;
    }

    app.component('SufficitIntegration', SufficitIntegration);
  },
};
